import React, { useState, useEffect, useRef } from 'react';
import ReactDOMServer from 'react-dom/server';
import { FaEdit, FaBold, FaItalic, FaUnderline, FaAlignLeft, FaAlignCenter, FaAlignRight, FaImage, FaVideo, FaCrop, FaFont, FaPalette, FaSave, FaTimes, FaStar, FaUndo, FaEye, FaFileAlt, FaBullseye, FaCheckCircle, FaShieldAlt, FaHandshake, FaLightbulb, FaAward, FaUsers, FaBuilding, FaHeart, FaChartLine, FaUserTie, FaPlay, FaPhone, FaEnvelope, FaMapMarkerAlt, FaGlobe, FaFacebook, FaTwitter, FaLinkedin, FaInstagram, FaYoutube, FaWhatsapp, FaHome, FaInfoCircle, FaCog, FaWrench, FaTools, FaHammer, FaTruck, FaHardHat, FaIndustry, FaWarehouse, FaRoad, FaCity, FaUniversity, FaHospital, FaSchool, FaStore, FaHotel, FaShoppingCart, FaCreditCard, FaMoneyBillWave, FaChartBar, FaChartPie, FaChartArea, FaCalculator, FaClipboardList, FaCalendarAlt, FaClock, FaBell, FaSearch, FaFilter, FaSort, FaDownload, FaUpload, FaPrint, FaShare, FaBookmark, FaThumbsUp, FaThumbsDown, FaComment, FaReply, FaForward, FaBackward, FaFastForward, FaFastBackward, FaPause, FaStop, FaVolumeUp, FaVolumeMute, FaVolumeDown, FaMicrophone, FaHeadphones, FaCamera, FaMusic, FaGamepad, FaDice, FaPuzzlePiece, FaChess, FaTrophy, FaMedal, FaCertificate, FaGraduationCap, FaBook, FaNewspaper, FaBlog, FaRss, FaPodcast, FaSpotify, FaApple, FaGoogle, FaMicrosoft, FaAmazon, FaDiscord, FaTelegram, FaReddit, FaGithub, FaStackOverflow, FaDev, FaMedium, FaBehance, FaDribbble, FaFigma, FaSketch, FaWordpress, FaShopify, FaMagento, FaOpencart, FaJoomla, FaDrupal, FaLaravel, FaReact, FaAngular, FaVuejs, FaNodeJs, FaPython, FaJava, FaPhp, FaDatabase, FaServer, FaCloud, FaLock, FaUnlock, FaKey, FaUserSecret, FaUserShield, FaUserCheck, FaUserTimes, FaUserPlus, FaUserMinus, FaUserEdit, FaUserCog, FaUserGraduate, FaUserNurse, FaUserMd, FaUserInjured, FaUserAstronaut, FaUserNinja, FaUserAlt, FaUserCircle, FaUserFriends, FaUserClock, FaUserTag, FaUserLock, FaUserSlash, FaTrash } from 'react-icons/fa';

interface InlineEditorProps {
  children: React.ReactNode;
  onSave: (data: any) => void;
  onCancel: () => void;
  onDelete?: (elementKey?: string) => void; // إضافة دالة الحذف
  language: 'ar' | 'en';
  sectionIndex?: number; // إضافة معرف السكشن
  sectionType?: string; // إضافة نوع السكشن
}

const InlineEditor: React.FC<InlineEditorProps> = ({
  children,
  onSave,
  onCancel,
  language,
  sectionIndex,
  sectionType,
  onDelete
}) => {
  const [isEditing, setIsEditing] = useState(true);
  const [selectedElement, setSelectedElement] = useState<HTMLElement | null>(null);
  const [textEditor, setTextEditor] = useState(false);
  const [imageEditor, setImageEditor] = useState(false);
  const [backgroundEditor, setBackgroundEditor] = useState(false);
  const [iconEditor, setIconEditor] = useState(false);
  const [editableText, setEditableText] = useState('');
  const [isEditingText, setIsEditingText] = useState(false);
  const [fontSize, setFontSize] = useState(16);
  const [fontFamily, setFontFamily] = useState('Arial');
  const [textColor, setTextColor] = useState('#000000');
  const [iconColor, setIconColor] = useState('#3b82f6');
  const [selectedIcon, setSelectedIcon] = useState<string>('');
  const [isBold, setIsBold] = useState(false);
  const [isItalic, setIsItalic] = useState(false);
  const [isUnderline, setIsUnderline] = useState(false);
  const [textAlign, setTextAlign] = useState<'left' | 'center' | 'right'>('left');
  
  // حفظ القيم الأصلية للتراجع
  const [originalStyles, setOriginalStyles] = useState<any>(null);
  const [originalText, setOriginalText] = useState('');
  
  // إضافة حالة لتتبع سياق التعديل
  const [editingContext, setEditingContext] = useState<{
    elementType: 'text' | 'image' | 'icon' | 'background';
    elementKey?: string; // المفتاح في البيانات (مثل: headline.ar, backgroundImage, etc.)
    elementPath?: string[]; // مسار العنصر في البيانات المتداخلة
  } | null>(null);

  // مكتبة الأيقونات
  const iconLibrary = [
    // أيقونات أساسية
    { name: 'Eye', component: FaEye, category: 'basic' },
    { name: 'File', component: FaFileAlt, category: 'basic' },
    { name: 'Target', component: FaBullseye, category: 'basic' },
    { name: 'Check', component: FaCheckCircle, category: 'basic' },
    { name: 'Shield', component: FaShieldAlt, category: 'basic' },
    { name: 'Handshake', component: FaHandshake, category: 'basic' },
    { name: 'Lightbulb', component: FaLightbulb, category: 'basic' },
    { name: 'Award', component: FaAward, category: 'basic' },
    { name: 'Users', component: FaUsers, category: 'basic' },
    { name: 'Building', component: FaBuilding, category: 'basic' },
    { name: 'Heart', component: FaHeart, category: 'basic' },
    { name: 'Chart', component: FaChartLine, category: 'basic' },
    { name: 'User', component: FaUserTie, category: 'basic' },
    { name: 'Star', component: FaStar, category: 'basic' },
    
    // أيقونات التواصل
    { name: 'Phone', component: FaPhone, category: 'communication' },
    { name: 'Email', component: FaEnvelope, category: 'communication' },
    { name: 'Location', component: FaMapMarkerAlt, category: 'communication' },
    { name: 'Globe', component: FaGlobe, category: 'communication' },
    { name: 'Facebook', component: FaFacebook, category: 'social' },
    { name: 'Twitter', component: FaTwitter, category: 'social' },
    { name: 'LinkedIn', component: FaLinkedin, category: 'social' },
    { name: 'Instagram', component: FaInstagram, category: 'social' },
    { name: 'YouTube', component: FaYoutube, category: 'social' },
    { name: 'WhatsApp', component: FaWhatsapp, category: 'social' },
    
    // أيقونات الأعمال
    { name: 'Home', component: FaHome, category: 'business' },
    { name: 'Info', component: FaInfoCircle, category: 'business' },
    { name: 'Settings', component: FaCog, category: 'business' },
    { name: 'Wrench', component: FaWrench, category: 'business' },
    { name: 'Tools', component: FaTools, category: 'business' },
    { name: 'Hammer', component: FaHammer, category: 'business' },
    { name: 'Truck', component: FaTruck, category: 'business' },
    { name: 'Hard Hat', component: FaHardHat, category: 'business' },
    { name: 'Industry', component: FaIndustry, category: 'business' },
    { name: 'Warehouse', component: FaWarehouse, category: 'business' },
    { name: 'Road', component: FaRoad, category: 'business' },
    { name: 'City', component: FaCity, category: 'business' },
    { name: 'University', component: FaUniversity, category: 'business' },
    { name: 'Hospital', component: FaHospital, category: 'business' },
    { name: 'School', component: FaSchool, category: 'business' },
    { name: 'Store', component: FaStore, category: 'business' },
    { name: 'Hotel', component: FaHotel, category: 'business' },
    
    // أيقونات المال والتجارة
    { name: 'Shopping Cart', component: FaShoppingCart, category: 'commerce' },
    { name: 'Credit Card', component: FaCreditCard, category: 'commerce' },
    { name: 'Money', component: FaMoneyBillWave, category: 'commerce' },
    { name: 'Chart Bar', component: FaChartBar, category: 'commerce' },
    { name: 'Chart Pie', component: FaChartPie, category: 'commerce' },
    { name: 'Chart Area', component: FaChartArea, category: 'commerce' },
    { name: 'Calculator', component: FaCalculator, category: 'commerce' },
    { name: 'Clipboard', component: FaClipboardList, category: 'commerce' },
    
    // أيقونات الوقت والتقويم
    { name: 'Calendar', component: FaCalendarAlt, category: 'time' },
    { name: 'Clock', component: FaClock, category: 'time' },
    { name: 'Bell', component: FaBell, category: 'time' },
    
    // أيقونات البحث والتنظيم
    { name: 'Search', component: FaSearch, category: 'tools' },
    { name: 'Filter', component: FaFilter, category: 'tools' },
    { name: 'Sort', component: FaSort, category: 'tools' },
    { name: 'Download', component: FaDownload, category: 'tools' },
    { name: 'Upload', component: FaUpload, category: 'tools' },
    { name: 'Print', component: FaPrint, category: 'tools' },
    { name: 'Share', component: FaShare, category: 'tools' },
    { name: 'Bookmark', component: FaBookmark, category: 'tools' },
    
    // أيقونات التفاعل
    { name: 'Thumbs Up', component: FaThumbsUp, category: 'interaction' },
    { name: 'Thumbs Down', component: FaThumbsDown, category: 'interaction' },
    { name: 'Comment', component: FaComment, category: 'interaction' },
    { name: 'Reply', component: FaReply, category: 'interaction' },
    
    // أيقونات الوسائط
    { name: 'Play', component: FaPlay, category: 'media' },
    { name: 'Forward', component: FaForward, category: 'media' },
    { name: 'Backward', component: FaBackward, category: 'media' },
    { name: 'Fast Forward', component: FaFastForward, category: 'media' },
    { name: 'Fast Backward', component: FaFastBackward, category: 'media' },
    { name: 'Pause', component: FaPause, category: 'media' },
    { name: 'Stop', component: FaStop, category: 'media' },
    { name: 'Volume Up', component: FaVolumeUp, category: 'media' },
    { name: 'Volume Mute', component: FaVolumeMute, category: 'media' },
    { name: 'Volume Down', component: FaVolumeDown, category: 'media' },
    { name: 'Microphone', component: FaMicrophone, category: 'media' },
    { name: 'Headphones', component: FaHeadphones, category: 'media' },
    { name: 'Camera', component: FaCamera, category: 'media' },
    { name: 'Video', component: FaVideo, category: 'media' },
    { name: 'Music', component: FaMusic, category: 'media' },
    
    // أيقونات الألعاب والترفيه
    { name: 'Gamepad', component: FaGamepad, category: 'entertainment' },
    { name: 'Dice', component: FaDice, category: 'entertainment' },
    { name: 'Puzzle', component: FaPuzzlePiece, category: 'entertainment' },
    { name: 'Chess', component: FaChess, category: 'entertainment' },
    { name: 'Trophy', component: FaTrophy, category: 'entertainment' },
    { name: 'Medal', component: FaMedal, category: 'entertainment' },
    { name: 'Certificate', component: FaCertificate, category: 'entertainment' },
    { name: 'Graduation', component: FaGraduationCap, category: 'entertainment' },
    
    // أيقونات التعليم والقراءة
    { name: 'Book', component: FaBook, category: 'education' },
    { name: 'Newspaper', component: FaNewspaper, category: 'education' },
    { name: 'Blog', component: FaBlog, category: 'education' },
    { name: 'RSS', component: FaRss, category: 'education' },
    { name: 'Podcast', component: FaPodcast, category: 'education' },
    
    // أيقونات التكنولوجيا
    { name: 'Spotify', component: FaSpotify, category: 'tech' },
    { name: 'Apple', component: FaApple, category: 'tech' },
    { name: 'Google', component: FaGoogle, category: 'tech' },
    { name: 'Microsoft', component: FaMicrosoft, category: 'tech' },
    { name: 'Amazon', component: FaAmazon, category: 'tech' },
    { name: 'Discord', component: FaDiscord, category: 'tech' },
    { name: 'Telegram', component: FaTelegram, category: 'tech' },
    { name: 'Reddit', component: FaReddit, category: 'tech' },
    { name: 'GitHub', component: FaGithub, category: 'tech' },
    { name: 'Stack Overflow', component: FaStackOverflow, category: 'tech' },
    { name: 'Dev', component: FaDev, category: 'tech' },
    { name: 'Medium', component: FaMedium, category: 'tech' },
    { name: 'Behance', component: FaBehance, category: 'tech' },
    { name: 'Dribbble', component: FaDribbble, category: 'tech' },
    { name: 'Figma', component: FaFigma, category: 'tech' },
    { name: 'Sketch', component: FaSketch, category: 'tech' },
    { name: 'WordPress', component: FaWordpress, category: 'tech' },
    { name: 'Shopify', component: FaShopify, category: 'tech' },
    { name: 'Magento', component: FaMagento, category: 'tech' },
    { name: 'OpenCart', component: FaOpencart, category: 'tech' },
    { name: 'Joomla', component: FaJoomla, category: 'tech' },
    { name: 'Drupal', component: FaDrupal, category: 'tech' },
    { name: 'Laravel', component: FaLaravel, category: 'tech' },
    { name: 'React', component: FaReact, category: 'tech' },
    { name: 'Angular', component: FaAngular, category: 'tech' },
    { name: 'Vue.js', component: FaVuejs, category: 'tech' },
    { name: 'Node.js', component: FaNodeJs, category: 'tech' },
    { name: 'Python', component: FaPython, category: 'tech' },
    { name: 'Java', component: FaJava, category: 'tech' },
    { name: 'PHP', component: FaPhp, category: 'tech' },
    { name: 'Database', component: FaDatabase, category: 'tech' },
    { name: 'Server', component: FaServer, category: 'tech' },
    { name: 'Cloud', component: FaCloud, category: 'tech' },
    
    // أيقونات الأمان
    { name: 'Lock', component: FaLock, category: 'security' },
    { name: 'Unlock', component: FaUnlock, category: 'security' },
    { name: 'Key', component: FaKey, category: 'security' },
    { name: 'User Secret', component: FaUserSecret, category: 'security' },
    { name: 'User Shield', component: FaUserShield, category: 'security' },
    { name: 'User Check', component: FaUserCheck, category: 'security' },
    { name: 'User Times', component: FaUserTimes, category: 'security' },
    { name: 'User Plus', component: FaUserPlus, category: 'security' },
    { name: 'User Minus', component: FaUserMinus, category: 'security' },
    { name: 'User Edit', component: FaUserEdit, category: 'security' },
    { name: 'User Cog', component: FaUserCog, category: 'security' },
    { name: 'User Graduate', component: FaUserGraduate, category: 'security' },
    { name: 'User Nurse', component: FaUserNurse, category: 'security' },
    { name: 'User MD', component: FaUserMd, category: 'security' },
    { name: 'User Injured', component: FaUserInjured, category: 'security' },
    { name: 'User Astronaut', component: FaUserAstronaut, category: 'security' },
    { name: 'User Ninja', component: FaUserNinja, category: 'security' },
    { name: 'User Alt', component: FaUserAlt, category: 'security' },
    { name: 'User Circle', component: FaUserCircle, category: 'security' },
    { name: 'User Friends', component: FaUserFriends, category: 'security' },
    { name: 'User Clock', component: FaUserClock, category: 'security' },
    { name: 'User Tag', component: FaUserTag, category: 'security' },
    { name: 'User Lock', component: FaUserLock, category: 'security' },
    { name: 'User Slash', component: FaUserSlash, category: 'security' }
  ];
  const [backgroundType, setBackgroundType] = useState<'color' | 'image' | 'video'>('color');
  const [backgroundColor, setBackgroundColor] = useState('#ffffff');
  const [backgroundImage, setBackgroundImage] = useState('');
  const [backgroundVideo, setBackgroundVideo] = useState('');
  const [imageScale, setImageScale] = useState(100);
  const [imageCrop, setImageCrop] = useState({ x: 0, y: 0, width: 100, height: 100 });

  const isRTL = language === 'ar';

  // إضافة event listeners للعناصر القابلة للتعديل
  useEffect(() => {
    if (isEditing) {
      const editableElements = document.querySelectorAll('[data-editable]');
      editableElements.forEach((element) => {
        element.addEventListener('click', handleElementClick);
        (element as HTMLElement).style.cursor = 'pointer';
        (element as HTMLElement).style.position = 'relative';
      });

      return () => {
        editableElements.forEach((element) => {
          element.removeEventListener('click', handleElementClick);
          (element as HTMLElement).style.cursor = '';
          (element as HTMLElement).style.position = '';
        });
      };
    }
  }, [isEditing]);

  const handleElementClick = (e: Event) => {
    e.preventDefault();
    e.stopPropagation();
    const element = e.target as HTMLElement;
    setSelectedElement(element);
    
    // تحديد نوع العنصر ومساره في البيانات
    let elementType: 'text' | 'image' | 'icon' | 'background' = 'text';
    let elementKey: string | undefined;
    let elementPath: string[] | undefined;
    
    // فحص نوع العنصر
    if (element.tagName === 'IMG') {
      elementType = 'image';
      // قراءة مفتاح الصورة من data attributes
      elementKey = element.getAttribute('data-image-key') || 'image';
      // قراءة مفتاح alt text إذا كان موجود
      const altKey = element.getAttribute('data-image-alt-key');
      if (altKey && (element as HTMLImageElement).alt !== '') {
        elementKey = altKey;
      }
    } else if (element.tagName === 'svg' || element.querySelector('svg')) {
      elementType = 'icon';
      elementKey = element.getAttribute('data-icon-key') || 'icon';
    } else if (element.hasAttribute('data-editable')) {
      elementType = 'text';
      // قراءة مفتاح النص من data attributes
      elementKey = element.getAttribute('data-text-key') || 'text';
    }
    
    // حفظ سياق التعديل
    setEditingContext({
      elementType,
      elementKey,
      elementPath
    });
    
    // استخراج الخصائص الحالية من العنصر
    const computedStyle = window.getComputedStyle(element);
    const currentStyles = {
      fontSize: element.style.fontSize || computedStyle.fontSize,
      fontFamily: element.style.fontFamily || computedStyle.fontFamily,
      color: element.style.color || computedStyle.color,
      fontWeight: element.style.fontWeight || computedStyle.fontWeight,
      fontStyle: element.style.fontStyle || computedStyle.fontStyle,
      textDecoration: element.style.textDecoration || computedStyle.textDecoration,
      textAlign: element.style.textAlign || computedStyle.textAlign
    };
    
    // حفظ القيم الأصلية
    setOriginalStyles(currentStyles);
    setOriginalText(element.textContent || '');
    
    // تعيين القيم الحالية للمحرر
    setFontSize(parseInt(currentStyles.fontSize) || 16);
    setFontFamily(currentStyles.fontFamily || 'Arial');
    setTextColor(currentStyles.color || '#000000');
    setIsBold(currentStyles.fontWeight === 'bold');
    setIsItalic(currentStyles.fontStyle === 'italic');
    setIsUnderline(currentStyles.textDecoration === 'underline');
    setTextAlign((currentStyles.textAlign as any) || 'left');
    setEditableText(element.textContent || '');
    
    // استخراج خصائص الأيقونة إذا كانت موجودة
    if (element.tagName === 'svg' || element.querySelector('svg')) {
      const icon = element.tagName === 'svg' ? element : element.querySelector('svg');
      if (icon) {
        const iconComputedStyle = window.getComputedStyle(icon);
        const iconSize = parseInt(icon.style.fontSize || icon.style.width || iconComputedStyle.fontSize || iconComputedStyle.width) || 16;
        setIconColor(icon.style.color || iconComputedStyle.color || '#3b82f6');
        setFontSize(iconSize);
        
        // تحديد الأيقونة الحالية
        const iconName = icon.getAttribute('data-icon-name') || 'Star';
        setSelectedIcon(iconName);
      }
    }
    
    if (element.tagName === 'IMG') {
      setImageEditor(true);
      setTextEditor(false);
      setIconEditor(false);
    } else if (element.tagName === 'svg' || element.querySelector('svg')) {
      setIconEditor(true);
      setTextEditor(false);
      setImageEditor(false);
    } else {
      setTextEditor(true);
      setImageEditor(false);
      setIconEditor(false);
    }
  };

  // دالة حذف العنصر
  const handleDeleteElement = () => {
    if (editingContext && onDelete) {
      const elementKey = editingContext.elementPath?.join('.') || editingContext.elementKey;
      onDelete(elementKey);
      
      // إغلاق المحرر
      setTextEditor(false);
      setImageEditor(false);
      setIconEditor(false);
      setBackgroundEditor(false);
      setSelectedElement(null);
      setEditingContext(null);
    }
  };

  // تطبيق التغييرات فوراً (معاينة فورية)
  const applyTextStyles = () => {
    if (!selectedElement) return;

    selectedElement.style.fontSize = `${fontSize}px`;
    selectedElement.style.fontFamily = fontFamily;
    selectedElement.style.color = textColor;
    selectedElement.style.fontWeight = isBold ? 'bold' : 'normal';
    selectedElement.style.fontStyle = isItalic ? 'italic' : 'normal';
    selectedElement.style.textDecoration = isUnderline ? 'underline' : 'none';
    selectedElement.style.textAlign = textAlign;
  };

  // تطبيق التغييرات فوراً عند تغيير أي قيمة
  useEffect(() => {
    if (selectedElement && textEditor) {
      applyTextStyles();
    }
  }, [fontSize, fontFamily, textColor, isBold, isItalic, isUnderline, textAlign, textEditor]);

  // تطبيق تغييرات الأيقونة فوراً
  useEffect(() => {
    if (selectedElement && iconEditor) {
      applyIconStyles();
    }
  }, [iconColor, fontSize, iconEditor]);

  // حفظ التغييرات نهائياً
  const saveChanges = () => {
    // جمع البيانات المعدلة
    const saveData: any = {
      sectionIndex,
      sectionType,
      editingContext,
      textStyles: {
        fontSize,
        fontFamily,
        textColor,
        isBold,
        isItalic,
        isUnderline,
        textAlign
      },
      textContent: editableText,
      iconStyles: {
        color: iconColor,
        size: fontSize
      }
    };

    // إذا كان العنصر المحدد صورة، أضف alt text
    if (selectedElement && selectedElement.tagName === 'IMG') {
      const img = selectedElement as HTMLImageElement;
      saveData.imageAlt = img.alt;
    }

    // هنا يمكن حفظ التغييرات في قاعدة البيانات
    console.log('Changes saved permanently');
    onSave(saveData);
  };

  // التراجع عن التغييرات
  const revertChanges = () => {
    if (!selectedElement || !originalStyles) return;

    // إعادة القيم الأصلية
    selectedElement.style.fontSize = originalStyles.fontSize;
    selectedElement.style.fontFamily = originalStyles.fontFamily;
    selectedElement.style.color = originalStyles.color;
    selectedElement.style.fontWeight = originalStyles.fontWeight;
    selectedElement.style.fontStyle = originalStyles.fontStyle;
    selectedElement.style.textDecoration = originalStyles.textDecoration;
    selectedElement.style.textAlign = originalStyles.textAlign;
    selectedElement.textContent = originalText;

    // إعادة تعيين قيم المحرر
    setFontSize(parseInt(originalStyles.fontSize) || 16);
    setFontFamily(originalStyles.fontFamily || 'Arial');
    setTextColor(originalStyles.color || '#000000');
    setIsBold(originalStyles.fontWeight === 'bold');
    setIsItalic(originalStyles.fontStyle === 'italic');
    setIsUnderline(originalStyles.textDecoration === 'underline');
    setTextAlign((originalStyles.textAlign as any) || 'left');
    setEditableText(originalText);
  };

  const applyIconStyles = () => {
    if (!selectedElement) return;

    const icon = selectedElement.tagName === 'svg' ? selectedElement : selectedElement.querySelector('svg');
    if (icon) {
      icon.style.color = iconColor;
      icon.style.fill = iconColor;
      icon.style.fontSize = `${fontSize}px`;
      icon.style.width = `${fontSize}px`;
      icon.style.height = `${fontSize}px`;
    }
  };

  const changeIcon = (iconName: string) => {
    if (!selectedElement) return;

    const iconData = iconLibrary.find(icon => icon.name === iconName);
    if (!iconData) return;

    const IconComponent = iconData.component;
    
    // البحث عن الأيقونة الحالية
    let currentIcon = selectedElement.tagName === 'svg' ? selectedElement : selectedElement.querySelector('svg');
    let iconContainer = selectedElement;
    
    // إذا كان العنصر المحدد ليس SVG، ابحث عن SVG داخل العنصر
    if (selectedElement.tagName !== 'svg') {
      currentIcon = selectedElement.querySelector('svg');
      if (currentIcon) {
        iconContainer = currentIcon.parentElement || selectedElement;
      }
    }
    
    if (iconContainer) {
      // إزالة الأيقونة القديمة
      if (currentIcon) {
        currentIcon.remove();
      }

      // إنشاء الأيقونة الجديدة
      const newIcon = document.createElement('div');
      newIcon.innerHTML = ReactDOMServer.renderToString(<IconComponent />);
      const svgElement = newIcon.querySelector('svg');
      
              if (svgElement) {
          // تطبيق الخصائص الحالية
          svgElement.style.color = iconColor;
          svgElement.style.fill = iconColor;
          svgElement.style.fontSize = `${fontSize}px`;
          svgElement.style.width = `${fontSize}px`;
          svgElement.style.height = `${fontSize}px`;
          
          // إضافة اسم الأيقونة كخاصية
          svgElement.setAttribute('data-icon-name', iconName);
          
          // إضافة الأيقونة في نفس مكان الأيقونة القديمة
          iconContainer.appendChild(svgElement);
          
          // تحديث العنصر المحدد ليكون الأيقونة الجديدة
          setSelectedElement(svgElement as unknown as HTMLElement);
        }
    }

    setSelectedIcon(iconName);
  };

  const updateTextContent = () => {
    if (!selectedElement || !editableText) return;
    selectedElement.textContent = editableText;
  };

  const applyImageStyles = () => {
    if (!selectedElement || selectedElement.tagName !== 'IMG') return;

    const img = selectedElement as HTMLImageElement;
    img.style.transform = `scale(${imageScale / 100})`;
    img.style.objectPosition = `${imageCrop.x}% ${imageCrop.y}%`;
    img.style.objectFit = 'cover';
  };

  const applyBackground = () => {
    const section = selectedElement?.closest('section') || document.querySelector('main');
    if (!section) return;

    switch (backgroundType) {
      case 'color':
        section.style.background = backgroundColor;
        section.style.backgroundImage = '';
        // Remove video background if exists
        const existingVideo = section.querySelector('video');
        if (existingVideo) {
          existingVideo.remove();
        }
        break;
      case 'image':
        section.style.background = `url(${backgroundImage})`;
        section.style.backgroundSize = 'cover';
        section.style.backgroundPosition = 'center';
        break;
      case 'video':
        // إضافة فيديو كخلفية
        const video = document.createElement('video');
        video.src = backgroundVideo;
        video.autoplay = true;
        video.loop = true;
        video.muted = true;
        video.style.position = 'absolute';
        video.style.top = '0';
        video.style.left = '0';
        video.style.width = '100%';
        video.style.height = '100%';
        video.style.objectFit = 'cover';
        video.style.zIndex = '-1';
        section.appendChild(video);
        break;
    }
  };

  const handleSave = () => {
    // جمع البيانات المعدلة
    const saveData: any = {
      sectionIndex,
      sectionType,
      editingContext,
      textStyles: {
        fontSize,
        fontFamily,
        textColor,
        isBold,
        isItalic,
        isUnderline,
        textAlign
      },
      textContent: editableText,
      iconStyles: {
        color: iconColor,
        size: fontSize
      }
    };

    // إذا كان العنصر المحدد صورة، أضف alt text
    if (selectedElement && selectedElement.tagName === 'IMG') {
      const img = selectedElement as HTMLImageElement;
      saveData.imageAlt = img.alt;
    }

    onSave(saveData);
    setIsEditing(false);
  };

  const handleSaveFinal = () => {
    // جمع البيانات المعدلة
    const saveData: any = {
      sectionIndex,
      sectionType,
      editingContext,
      textStyles: {
        fontSize,
        fontFamily,
        textColor,
        isBold,
        isItalic,
        isUnderline,
        textAlign
      },
      textContent: editableText,
      iconStyles: {
        color: iconColor,
        size: fontSize
      }
    };

    // إذا كان العنصر المحدد صورة، أضف alt text
    if (selectedElement && selectedElement.tagName === 'IMG') {
      const img = selectedElement as HTMLImageElement;
      saveData.imageAlt = img.alt;
    }

    onSave(saveData);
    setIsEditing(false);
  };

  return (
    <div className="inline-editor">
      {/* زر تفعيل التعديل */}
      {!isEditing && (
        <div className="fixed top-4 right-4 z-50">
          <button
            onClick={() => setIsEditing(true)}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg shadow-lg hover:bg-blue-700 flex items-center"
          >
            <FaEdit className="mr-2" />
            {isRTL ? 'بدء التعديل' : 'Start Editing'}
          </button>
        </div>
      )}

      {/* شريط الأدوات العلوي */}
      {isEditing && (
        <div className="fixed top-0 left-0 right-0 bg-white border-b shadow-lg z-50 p-4">
          <div className="flex items-center justify-between max-w-6xl mx-auto">
            <div className="flex items-center space-x-4 rtl:space-x-reverse">
              <button
                onClick={() => setBackgroundEditor(!backgroundEditor)}
                className={`px-3 py-2 rounded ${backgroundEditor ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
              >
                <FaImage className="inline mr-2" />
                {isRTL ? 'خلفية' : 'Background'}
              </button>
              
              <button
                onClick={() => setTextEditor(!textEditor)}
                className={`px-3 py-2 rounded ${textEditor ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
              >
                <FaFont className="inline mr-2" />
                {isRTL ? 'نص' : 'Text'}
              </button>
              
              <button
                onClick={() => setImageEditor(!imageEditor)}
                className={`px-3 py-2 rounded ${imageEditor ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
              >
                <FaImage className="inline mr-2" />
                {isRTL ? 'صورة' : 'Image'}
              </button>
              
              <button
                onClick={() => setIconEditor(!iconEditor)}
                className={`px-3 py-2 rounded ${iconEditor ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
              >
                <FaStar className="inline mr-2" />
                {isRTL ? 'أيقونة' : 'Icon'}
              </button>

              {/* زر الحذف */}
              {selectedElement && onDelete && (
                <button
                  onClick={() => {
                    if (window.confirm(isRTL ? 'هل أنت متأكد من حذف هذا العنصر؟' : 'Are you sure you want to delete this element?')) {
                      onDelete(editingContext?.elementKey);
                    }
                  }}
                  className="px-3 py-2 rounded bg-red-500 hover:bg-red-600 text-white transition-colors"
                >
                  <FaTrash className="inline mr-2" />
                  {isRTL ? 'حذف' : 'Delete'}
                </button>
              )}
            </div>

            <div className="flex items-center space-x-2 rtl:space-x-reverse">
              <button
                onClick={saveChanges}
                className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
              >
                <FaSave className="inline mr-2" />
                {isRTL ? 'حفظ نهائي' : 'Save Final'}
              </button>
              <button
                onClick={revertChanges}
                className="bg-yellow-500 text-white px-4 py-2 rounded hover:bg-yellow-600"
              >
                <FaUndo className="inline mr-2" />
                {isRTL ? 'تراجع' : 'Revert'}
              </button>
              <button
                onClick={onCancel}
                className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
              >
                <FaTimes className="inline mr-2" />
                {isRTL ? 'إغلاق' : 'Close'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* محرر الصور */}
      {imageEditor && isEditing && (
        <div className="fixed top-16 right-4 bg-white border shadow-lg rounded-lg p-4 z-40 w-80">
          <h3 className="font-bold mb-4">{isRTL ? 'تحرير الصورة' : 'Image Editor'}</h3>
          
          {/* عرض خصائص الصورة الحالية */}
          <div className="mb-4 p-3 bg-gray-50 rounded border">
            <h4 className="text-sm font-semibold mb-2 text-gray-700">{isRTL ? 'خصائص الصورة الحالية:' : 'Current Image Properties:'}</h4>
            <div className="text-xs space-y-1 text-gray-600">
              <div><span className="font-medium">{isRTL ? 'المصدر:' : 'Source:'}</span> 
                {(selectedElement as HTMLImageElement)?.src?.substring(0, 30) || 'N/A'}...
              </div>
              <div><span className="font-medium">{isRTL ? 'النص البديل:' : 'Alt Text:'}</span> 
                {(selectedElement as HTMLImageElement)?.alt || 'N/A'}
              </div>
              <div><span className="font-medium">{isRTL ? 'الحجم:' : 'Size:'}</span> 
                {imageScale}%
              </div>
              <div><span className="font-medium">{isRTL ? 'الموضع:' : 'Position:'}</span> 
                {imageCrop.x}%, {imageCrop.y}%
              </div>
            </div>
          </div>
          
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-2">{isRTL ? 'رابط الصورة' : 'Image URL'}</label>
              <input
                type="text"
                value={backgroundImage}
                onChange={(e) => setBackgroundImage(e.target.value)}
                placeholder={isRTL ? 'أدخل رابط الصورة' : 'Enter image URL'}
                className="w-full p-2 border rounded"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">{isRTL ? 'النص البديل' : 'Alt Text'}</label>
              <input
                type="text"
                value={(selectedElement as HTMLImageElement)?.alt || ''}
                onChange={(e) => {
                  if (selectedElement) {
                    (selectedElement as HTMLImageElement).alt = e.target.value;
                  }
                }}
                placeholder={isRTL ? 'أدخل النص البديل' : 'Enter alt text'}
                className="w-full p-2 border rounded"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">{isRTL ? 'حجم الصورة' : 'Image Scale'}</label>
              <input
                type="range"
                min="10"
                max="200"
                value={imageScale}
                onChange={(e) => setImageScale(Number(e.target.value))}
                className="w-full"
              />
              <span className="text-sm text-gray-600">{imageScale}%</span>
            </div>

            <div className="text-sm text-gray-600 bg-blue-50 p-2 rounded">
              {isRTL ? '💡 التغييرات تُطبق فوراً أثناء التعديل' : '💡 Changes are applied instantly while editing'}
            </div>
          </div>
          {imageEditor && isEditing && (
            <div className="flex gap-2 mt-6 justify-end">
              <button
                className="bg-blue-600 text-white px-6 py-2 rounded font-bold hover:bg-blue-700 transition"
                onClick={handleSaveFinal}
              >
                حفظ
              </button>
              <button
                className="bg-gray-300 text-gray-800 px-6 py-2 rounded font-bold hover:bg-gray-400 transition"
                onClick={onCancel}
              >
                إلغاء
              </button>
            </div>
          )}
        </div>
      )}

      {/* محرر الخلفية */}
      {backgroundEditor && isEditing && (
        <div className="fixed top-16 left-4 bg-white border shadow-lg rounded-lg p-4 z-40 w-80">
          <h3 className="font-bold mb-4">{isRTL ? 'تحرير الخلفية' : 'Background Editor'}</h3>
          
          {/* عرض خصائص الخلفية الحالية */}
          <div className="mb-4 p-3 bg-gray-50 rounded border">
            <h4 className="text-sm font-semibold mb-2 text-gray-700">{isRTL ? 'خصائص الخلفية الحالية:' : 'Current Background Properties:'}</h4>
            <div className="text-xs space-y-1 text-gray-600">
              <div><span className="font-medium">{isRTL ? 'النوع:' : 'Type:'}</span> {backgroundType}</div>
              {backgroundType === 'color' && (
                <div><span className="font-medium">{isRTL ? 'اللون:' : 'Color:'}</span> 
                  <span className="inline-block w-4 h-4 rounded border ml-1" style={{ backgroundColor: backgroundColor }}></span>
                  {backgroundColor}
                </div>
              )}
              {backgroundType === 'image' && (
                <div><span className="font-medium">{isRTL ? 'الصورة:' : 'Image:'}</span> 
                  {backgroundImage ? backgroundImage.substring(0, 30) + '...' : 'N/A'}
                </div>
              )}
              {backgroundType === 'video' && (
                <div><span className="font-medium">{isRTL ? 'الفيديو:' : 'Video:'}</span> 
                  {backgroundVideo ? backgroundVideo.substring(0, 30) + '...' : 'N/A'}
                </div>
              )}
            </div>
          </div>
          
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-2">{isRTL ? 'نوع الخلفية' : 'Background Type'}</label>
              <select
                value={backgroundType}
                onChange={(e) => setBackgroundType(e.target.value as any)}
                className="w-full p-2 border rounded"
              >
                <option value="color">{isRTL ? 'لون' : 'Color'}</option>
                <option value="image">{isRTL ? 'صورة' : 'Image'}</option>
                <option value="video">{isRTL ? 'فيديو' : 'Video'}</option>
              </select>
            </div>

            {backgroundType === 'color' && (
              <div>
                <label className="block text-sm font-medium mb-2">{isRTL ? 'لون الخلفية' : 'Background Color'}</label>
                <input
                  type="color"
                  value={backgroundColor}
                  onChange={(e) => setBackgroundColor(e.target.value)}
                  className="w-full h-10 border rounded"
                />
              </div>
            )}

            {backgroundType === 'image' && (
              <div>
                <label className="block text-sm font-medium mb-2">{isRTL ? 'رابط الصورة' : 'Image URL'}</label>
                <input
                  type="text"
                  value={backgroundImage}
                  onChange={(e) => setBackgroundImage(e.target.value)}
                  placeholder={isRTL ? 'أدخل رابط الصورة' : 'Enter image URL'}
                  className="w-full p-2 border rounded"
                />
              </div>
            )}

            {backgroundType === 'video' && (
              <div>
                <label className="block text-sm font-medium mb-2">{isRTL ? 'رابط الفيديو' : 'Video URL'}</label>
                <input
                  type="text"
                  value={backgroundVideo}
                  onChange={(e) => setBackgroundVideo(e.target.value)}
                  placeholder={isRTL ? 'أدخل رابط الفيديو' : 'Enter video URL'}
                  className="w-full p-2 border rounded"
                />
              </div>
            )}

            <button
              onClick={applyBackground}
              className="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600"
            >
              {isRTL ? 'تطبيق' : 'Apply'}
            </button>
          </div>
        </div>
      )}

      {/* محرر النصوص */}
      {textEditor && isEditing && (
        <div className="fixed top-16 right-4 bg-white border shadow-lg rounded-lg p-4 z-40 w-80">
          <h3 className="font-bold mb-4">{isRTL ? 'تحرير النص' : 'Text Editor'}</h3>
          
          {/* عرض الخصائص الحالية */}
          <div className="mb-4 p-3 bg-gray-50 rounded border">
            <h4 className="text-sm font-semibold mb-2 text-gray-700">{isRTL ? 'الخصائص الحالية:' : 'Current Properties:'}</h4>
            <div className="text-xs space-y-1 text-gray-600">
              <div><span className="font-medium">{isRTL ? 'النص:' : 'Text:'}</span> {editableText.substring(0, 30)}{editableText.length > 30 ? '...' : ''}</div>
              <div><span className="font-medium">{isRTL ? 'حجم الخط:' : 'Font Size:'}</span> {fontSize}px</div>
              <div><span className="font-medium">{isRTL ? 'نوع الخط:' : 'Font Family:'}</span> {fontFamily}</div>
              <div><span className="font-medium">{isRTL ? 'لون النص:' : 'Text Color:'}</span> 
                <span className="inline-block w-4 h-4 rounded border ml-1" style={{ backgroundColor: textColor }}></span>
                {textColor}
              </div>
              <div><span className="font-medium">{isRTL ? 'التنسيق:' : 'Format:'}</span> 
                {isBold && <span className="bg-blue-100 text-blue-800 px-1 rounded mr-1">Bold</span>}
                {isItalic && <span className="bg-blue-100 text-blue-800 px-1 rounded mr-1">Italic</span>}
                {isUnderline && <span className="bg-blue-100 text-blue-800 px-1 rounded mr-1">Underline</span>}
                {!isBold && !isItalic && !isUnderline && <span className="text-gray-400">Normal</span>}
              </div>
              <div><span className="font-medium">{isRTL ? 'المحاذاة:' : 'Alignment:'}</span> {textAlign}</div>
            </div>
          </div>
          
          {/* محرر النص المباشر */}
          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">{isRTL ? 'النص' : 'Text Content'}</label>
            <textarea
              value={editableText}
              onChange={(e) => setEditableText(e.target.value)}
              className="w-full p-2 border rounded resize-none"
              rows={3}
              placeholder={isRTL ? 'أدخل النص هنا...' : 'Enter text here...'}
            />
            <div className="flex gap-2 mt-6 justify-end">
              <button
                className="bg-green-600 text-white px-6 py-2 rounded font-bold hover:bg-green-700 transition"
                onClick={handleSaveFinal}
              >
                حفظ
              </button>
              <button
                className="bg-gray-300 text-gray-800 px-6 py-2 rounded font-bold hover:bg-gray-400 transition"
                onClick={onCancel}
              >
                إلغاء
              </button>
            </div>
          </div>
          
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-2">{isRTL ? 'حجم الخط' : 'Font Size'}</label>
              <input
                type="range"
                min="8"
                max="72"
                value={fontSize}
                onChange={(e) => setFontSize(Number(e.target.value))}
                className="w-full"
              />
              <span className="text-sm text-gray-600">{fontSize}px</span>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">{isRTL ? 'نوع الخط' : 'Font Family'}</label>
              <select
                value={fontFamily}
                onChange={(e) => setFontFamily(e.target.value)}
                className="w-full p-2 border rounded"
              >
                <option value="Arial">Arial</option>
                <option value="Times New Roman">Times New Roman</option>
                <option value="Helvetica">Helvetica</option>
                <option value="Georgia">Georgia</option>
                <option value="Verdana">Verdana</option>
                <option value="Cairo">Cairo</option>
                <option value="Montserrat">Montserrat</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">{isRTL ? 'لون النص' : 'Text Color'}</label>
              <input
                type="color"
                value={textColor}
                onChange={(e) => setTextColor(e.target.value)}
                className="w-full h-10 border rounded"
              />
            </div>

            <div className="flex space-x-2 rtl:space-x-reverse">
              <button
                onClick={() => setIsBold(!isBold)}
                className={`px-3 py-2 rounded ${isBold ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
              >
                <FaBold />
              </button>
              <button
                onClick={() => setIsItalic(!isItalic)}
                className={`px-3 py-2 rounded ${isItalic ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
              >
                <FaItalic />
              </button>
              <button
                onClick={() => setIsUnderline(!isUnderline)}
                className={`px-3 py-2 rounded ${isUnderline ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
              >
                <FaUnderline />
              </button>
            </div>

            <div className="flex space-x-2 rtl:space-x-reverse">
              <button
                onClick={() => setTextAlign('left')}
                className={`px-3 py-2 rounded ${textAlign === 'left' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
              >
                <FaAlignLeft />
              </button>
              <button
                onClick={() => setTextAlign('center')}
                className={`px-3 py-2 rounded ${textAlign === 'center' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
              >
                <FaAlignCenter />
              </button>
              <button
                onClick={() => setTextAlign('right')}
                className={`px-3 py-2 rounded ${textAlign === 'right' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
              >
                <FaAlignRight />
              </button>
            </div>

            <div className="text-sm text-gray-600 bg-blue-50 p-2 rounded">
              {isRTL ? '💡 التغييرات تُطبق فوراً أثناء التعديل' : '💡 Changes are applied instantly while editing'}
            </div>
          </div>
        </div>
      )}

      {/* محرر الصور */}
      {imageEditor && isEditing && (
        <div className="fixed top-16 left-4 bg-white border shadow-lg rounded-lg p-4 z-40 w-80">
          <h3 className="font-bold mb-4">{isRTL ? 'تحرير الصورة' : 'Image Editor'}</h3>
          
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-2">{isRTL ? 'حجم الصورة' : 'Image Scale'}</label>
              <input
                type="range"
                min="10"
                max="200"
                value={imageScale}
                onChange={(e) => setImageScale(Number(e.target.value))}
                className="w-full"
              />
              <span className="text-sm text-gray-600">{imageScale}%</span>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">{isRTL ? 'رابط الصورة الجديد' : 'New Image URL'}</label>
              <input
                type="text"
                placeholder={isRTL ? 'أدخل رابط الصورة الجديد' : 'Enter new image URL'}
                className="w-full p-2 border rounded"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">{isRTL ? 'نص بديل للصورة' : 'Image Alt Text'}</label>
              <input
                type="text"
                placeholder={isRTL ? 'أدخل نص بديل للصورة' : 'Enter alt text for image'}
                className="w-full p-2 border rounded"
              />
            </div>

            <button
              onClick={applyImageStyles}
              className="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600"
            >
              {isRTL ? 'تطبيق' : 'Apply'}
            </button>
          </div>
        </div>
      )}

      {/* محرر الأيقونات */}
      {iconEditor && isEditing && (
        <div className="fixed top-16 left-4 bg-white border shadow-lg rounded-lg p-4 z-40 w-96 max-h-[80vh] overflow-y-auto">
          <h3 className="font-bold mb-4">{isRTL ? 'تحرير الأيقونة' : 'Icon Editor'}</h3>
          
          {/* عرض الخصائص الحالية للأيقونة */}
          <div className="mb-4 p-3 bg-gray-50 rounded border">
            <h4 className="text-sm font-semibold mb-2 text-gray-700">{isRTL ? 'خصائص الأيقونة الحالية:' : 'Current Icon Properties:'}</h4>
            <div className="text-xs space-y-1 text-gray-600">
              <div><span className="font-medium">{isRTL ? 'نوع الأيقونة:' : 'Icon Type:'}</span> {selectedIcon || 'Default'}</div>
              <div><span className="font-medium">{isRTL ? 'لون الأيقونة:' : 'Icon Color:'}</span> 
                <span className="inline-block w-4 h-4 rounded border ml-1" style={{ backgroundColor: iconColor }}></span>
                {iconColor}
              </div>
              <div><span className="font-medium">{isRTL ? 'حجم الأيقونة:' : 'Icon Size:'}</span> {fontSize}px</div>
            </div>
          </div>
          
          <div className="space-y-4">
            {/* اختيار الأيقونة */}
            <div>
              <label className="block text-sm font-medium mb-2">{isRTL ? 'اختر الأيقونة' : 'Select Icon'}</label>
              <div className="grid grid-cols-6 gap-2 max-h-48 overflow-y-auto border rounded p-2">
                {iconLibrary.map((icon) => {
                  const IconComponent = icon.component;
                  return (
                    <button
                      key={icon.name}
                      onClick={() => changeIcon(icon.name)}
                      className={`p-2 border rounded hover:bg-blue-50 transition-colors ${
                        selectedIcon === icon.name ? 'bg-blue-100 border-blue-300' : 'bg-white'
                      }`}
                      title={icon.name}
                    >
                      <IconComponent className="w-4 h-4 mx-auto" />
                    </button>
                  );
                })}
              </div>
            </div>

            {/* لون الأيقونة */}
            <div>
              <label className="block text-sm font-medium mb-2">{isRTL ? 'لون الأيقونة' : 'Icon Color'}</label>
              <input
                type="color"
                value={iconColor}
                onChange={(e) => setIconColor(e.target.value)}
                className="w-full h-10 border rounded"
              />
            </div>

            {/* حجم الأيقونة */}
            <div>
              <label className="block text-sm font-medium mb-2">{isRTL ? 'حجم الأيقونة' : 'Icon Size'}</label>
              <input
                type="range"
                min="12"
                max="48"
                value={fontSize}
                onChange={(e) => setFontSize(Number(e.target.value))}
                className="w-full"
              />
              <span className="text-sm text-gray-600">{fontSize}px</span>
            </div>

            {/* معاينة الأيقونة */}
            <div>
              <label className="block text-sm font-medium mb-2">{isRTL ? 'معاينة الأيقونة' : 'Icon Preview'}</label>
              <div className="border rounded p-4 bg-gray-50 flex items-center justify-center">
                {selectedIcon ? (
                  (() => {
                    const iconData = iconLibrary.find(icon => icon.name === selectedIcon);
                    if (iconData) {
                      const IconComponent = iconData.component;
                      return (
                        <IconComponent 
                          style={{ 
                            color: iconColor, 
                            fontSize: `${fontSize}px` 
                          }} 
                        />
                      );
                    }
                    return <FaStar style={{ color: iconColor, fontSize: `${fontSize}px` }} />;
                  })()
                ) : (
                  <FaStar style={{ color: iconColor, fontSize: `${fontSize}px` }} />
                )}
              </div>
            </div>

            <div className="text-sm text-gray-600 bg-blue-50 p-2 rounded">
              {isRTL ? '💡 التغييرات تُطبق فوراً أثناء التعديل' : '💡 Changes are applied instantly while editing'}
            </div>
          </div>
        </div>
      )}

      {/* المحتوى مع علامات التعديل */}
      <div className={`${isEditing ? 'pt-20' : ''}`}>
        {React.Children.map(children, (child) => {
          if (React.isValidElement(child)) {
            return React.cloneElement(child, {
              className: `${child.props.className || ''} ${isEditing ? 'editable-element' : ''}`,
              ...(isEditing && { 'data-editable': 'true' })
            } as any);
          }
          return child;
        })}
      </div>

      <style dangerouslySetInnerHTML={{
        __html: `
          .editable-element {
            position: relative;
            transition: all 0.3s ease;
          }
          
          .editable-element:hover {
            outline: 2px dashed #3b82f6;
            outline-offset: 2px;
          }
          
          .editable-element:hover::after {
            content: '✏️';
            position: absolute;
            top: -10px;
            right: -10px;
            background: #3b82f6;
            color: white;
            border-radius: 50%;
            width: 30px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            cursor: pointer;
            z-index: 1000;
            box-shadow: 0 2px 8px rgba(0,0,0,0.2);
            animation: pulse 2s infinite;
          }
          
          .editable-element[data-editable="true"] {
            border: 2px dashed transparent;
            cursor: pointer;
          }
          
          .editable-element[data-editable="true"]:hover {
            border-color: #3b82f6;
            transform: scale(1.01);
          }
          
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.1); }
            100% { transform: scale(1); }
          }
          
          /* تحسين علامات التعديل للنصوص */
          h1, h2, h3, h4, h5, h6, p, span, div {
            position: relative;
          }
          
          /* تحسين علامات التعديل للصور */
          img {
            position: relative;
          }
          
          img:hover::after {
            content: '🖼️';
            position: absolute;
            top: -10px;
            right: -10px;
            background: #10b981;
            color: white;
            border-radius: 50%;
            width: 30px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            cursor: pointer;
            z-index: 1000;
            box-shadow: 0 2px 8px rgba(0,0,0,0.2);
            animation: pulse 2s infinite;
          }
          
          /* تحسين علامات التعديل للأيقونات */
          svg, .icon-container {
            position: relative;
          }
          
          svg:hover::after, .icon-container:hover::after {
            content: '⭐';
            position: absolute;
            top: -10px;
            right: -10px;
            background: #f59e0b;
            color: white;
            border-radius: 50%;
            width: 30px;
            height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            cursor: pointer;
            z-index: 1000;
            box-shadow: 0 2px 8px rgba(0,0,0,0.2);
            animation: pulse 2s infinite;
          }
        `
      }} />
    </div>
  );
};

export default InlineEditor; 